
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface HospitalSettingsParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}

export interface HospitalSettings {
  multiPropertyJson ?:string;
  phIpDisplayFormat?:string;
  phIPDisplayMode?:string;
  phIPService?:string;
  pharmacyBillIntegrationIPBill?:string;
  accessPatientAccrossAllbranches?:String;
  Auto_RoomRent_Charges_Flag: string;
  Auto_DoctorVisit_Charges_Flag: string;
  phOPCredit: string;
  phIPCredit: string;
  phDSCredit: string;
  phhideGSTSalesPrint: string;
  gstforFreeQty: string;
    tenantId?: string;
    branchId?: string;
    parameters?: HospitalSettingsParameter[];
    links?: any;
    serviceId: string;
    stockAlterDue: string;
    growthChartfromMonth:number;
    growthCharttoMonth:number;
    unitFlag?:string;
    labResultAlert?:string;
    LabTestNotes?:string;
    ipBillServiceDisplayOrderBy?:string;
    LabGrpNotes?:string
    wardWisePriceSetting?:string,
    phBillMobileMandatory?:any,
     printTemplateSetting:string;
     labReportTimelineFlag: string;
     LabAbnormalValueFlag?:string;
     WarehouseFlag?:string;
     restrictLoginByIPAddress?:string;
     automaticPostCharges?:string;
     registrationServiceId?:string;
     registrationCharge?:number;
     registrationDoctorId?:string;
     genarateBillBeforeCheckIn?:string;
     enableCheckInIfNoDues?:string;
     enableCheckOutIfNoDues?:string;

     iPBillNotes?:string;
     iPDisApprovalRequired?:string;
     eachIPApprovalRequired?:string;
     ipServiceHideRate?:string;
     dischargeSummaryType?:string;

     automaticVentilatorCharge?:string;
     ventilatorServiceId?:string;
     automaticEquipmentCharge?:string;
     equipmentServiceId?:string;
     automaticOxygenCharge?:string;
     oxygenServiceId?:string;
     automaticMonitorCharge?:string;
     monitorServiceId?:string;
     labOrderingFlag?:string;
     enableSalesScheme?:string;
     vaccineService?:string;
     ipServicePagination?:boolean,
    thresholdCommission?: Number,
    skipPhysicianRevenueIfOverDiscount?: boolean,
    splitRevenueIfPartialPayment?: boolean,
     combineOldBills:boolean;

    updateConsultationType:boolean;
    allowServiceDiscWithHealthcard:boolean;
    loadPoProducts:boolean;
}

export abstract class HospitalSettingsData {

  abstract list(url: string): Observable<HospitalSettings[]>;
  abstract roomRentList(url: string): Observable<any>;
  abstract create(url: string,data: HospitalSettings): Observable<any>;
  abstract update(url: string,data: HospitalSettings): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
